/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from "react";

import { withTranslation } from "react-i18next";
import { FormGroup, Label, UncontrolledTooltip } from "reactstrap";

import { useSelector } from "react-redux";

//import Select from "react-select";
import Switch from "react-switch";

import CustomFormRepeater from "../../Common/CustomFormRepeater";

// Custom methods
import { isFunction } from "../../../Libs/CustomMethods/customMethods";

// Theme style
import "./../ChatEvent/lightTheme.scss";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./../ChatEvent/darkTheme.scss");
  }
};

const BalancingComponent = ({ t, ...props }) => {
  const [balanceValues, setBalanceValues] = useState(props?.value);
  const [errors, setErrors] = useState({});
  const [totalpercent, setTotalPercent] = useState(0);
  const { mainTheme } = useSelector((state) => state.Layout);

  importDarkMode(mainTheme);

  const style = {
    width: props?.width ?? "auto",
    ...props?.style,
  };

  const toggleSwitch = () => {
    if (!props?.defaultValue?.balancer_type && !balanceValues.balancer) {
      setBalanceValues({
        ...balanceValues,
        balancer_type: "proportional",
        balancer: !balanceValues.balancer,
      });
    } else {
      setBalanceValues({
        ...balanceValues,
        balancer: !balanceValues.balancer,
      });
    }
  };

  const optionsGroups = useCallback((selectedValues) => {
    let optionsBalancerGroups = [];

    if (props?.groups?.length > 0) {
      props.groups.map((item) =>
        optionsBalancerGroups.push({
          key: item.id,
          value: item,
          label: item.name,
        })
      );
    } else {
      optionsBalancerGroups.push({
        value: "empty",
        label: t("No matching records found"),
        isDisabled: true,
      });
    }
    //Remove this conditional to permmit add multiple questions of same language
    if (selectedValues) {
      optionsBalancerGroups = optionsBalancerGroups.filter(
        (n) => !selectedValues.map((item) => item.group.id).includes(n.key)
      );
    }
    return optionsBalancerGroups;
  }, [props?.groups]);

  const tooltipsTypeBalancing = () => {
    return (
      <UncontrolledTooltip
        placement="bottom"
        target={`eventInfoType-${props?.id}`}
      >
        {t(
          "For the proportional type, the load percentage will be considered for the calculation, in the sequential only the groups."
        )}
      </UncontrolledTooltip>
    );
  };
  useEffect(() => {
    if (errors)
      setTimeout(() => {
        setErrors(false);
      }, 3000);
  }, [errors]);

  useEffect(() => {
    if (balanceValues.balancer_type === "proportional") {
      setTotal(balanceValues.balancer_config);
    }
  }, [balanceValues.balancer_config]);

  const proportionalFields = useMemo(() => {
    return [
      {
        label: t("Group") + " *",
        name: "group",
        group: true,
        select: true,
        inputProps: {
          className: "select2-container",
          classNamePrefix: "select2-selection",
          placeholder: t("Choose") + "...",
          options: optionsGroups(balanceValues?.balancer_config),
        },
        colProps: { className: "mb-3" },

        labelProps: {
          className: "font-weight-light",
        },
      },
      {
        label: t("Carga de trabalho") + " *",
        name: "carga",
        percentIcon: true,
        colProps: { className: "mb-3" },
        labelProps: {
          className: "font-weight-light",
        },
        inputProps: {
          className: "form-control",
          placeholder: t("Carga (1% a 100%)") + "...",
          type: "number",
        },
      },
    ]
  }, [balanceValues?.balancer_config, optionsGroups]);

  const sequentialFields = useMemo(() => {
    return [
      {
        label: t("Group") + " *",
        name: "group",
        group: true,
        select: true,
        inputProps: {
          className: "select2-container",
          classNamePrefix: "select2-selection",
          placeholder: t("Choose") + "...",
          options: optionsGroups(balanceValues?.balancer_config),
        },
        colProps: { className: "mb-3" },

        labelProps: {
          className: "font-weight-light",
        },
      },
    ]
  }, [balanceValues?.balancer_config, optionsGroups]);


  useEffect(() => {
    isFunction(props.onChange) && props.onChange(balanceValues);
  }, [balanceValues]);

  useEffect(() => {
    if (props?.defaultValue?.balancer_type === "proportional") {
      setTotal(props?.defaultValue?.balancer_config);
    }
    const aux = props?.defaultValue;
    setBalanceValues(aux);
  }, [props.defaultValue]);

  const setTotal = (balancer_config) => {
    let total = 0;
    balancer_config?.map((item) => {
      total = total + parseInt(item?.carga);
    });
    setTotalPercent(total);
    if (total === 100) {
      setBalanceValues({
        ...balanceValues,
        percentTotal: true,
      });
    } else {
      setBalanceValues({
        ...balanceValues,
        percentTotal: false,
      });
    }
  };

  const isValidTotal = (balancer_config) => {
    let total = 0;
    const error = {};
    let ultimo = 0;
    //isso ocorre no delete
    if (typeof balancer_config[0] === "undefined") {
      ultimo = 1;
    } else {
      ultimo = parseInt(balancer_config[0]?.carga);
    }

    balancer_config?.map((item) => {
      total = total + parseInt(item?.carga);
    });

    if (total === 100 && ultimo > 0) {
      error.bool = true;
    } else if (total < 100 && ultimo > 0) {
      error.bool = true;
      error.message = "O total da cargas precisa ser igual a 100%";
    } else if (total > 100) {
      error.bool = false;
      error.message = "Total must be less or equal 100";
    } else if (ultimo === 0) {
      error.bool = false;
      error.message = "The load must be greater than 0";
    }
    return error;
  };
  const handleRadioChange = (e) => {
    // using es6 computed property name
    setBalanceValues({
      ...balanceValues,
      balancer_type: e.target.value,
      balancer_config: null,
    });
  };
  const handleAddGroups = (e) => {
    let result = {};
    if (balanceValues.balancer_type === "proportional") {
      result = isValidTotal(e);
    } else {
      result.bool = true;
    }

    if (result.bool) {
      setBalanceValues({
        ...balanceValues,
        balancer_config: e,
      });
      setErrors({
        ...errors,
        groupCarga: { message: result.message },
      });
    } else {
      setErrors({
        ...errors,
        groupCarga: { message: result.message },
      });
    }
  };
  const balancerSwitch = () => {
    return (
      <div className="d-flex justify-content-between w-100">
        <Label className="d-flex control-label font-weight-bold align-items-center pr-2">
          {t("Advanced workload distribution")}
          <i
            className="fas fa-info-circle px-2 pointer"
            id={`balancer`}
          ></i>
        </Label>
        <div>
          <div onClick={toggleSwitch}>
            <Switch
              id={`eventToggle-${props?.id}`}
              className="chat-event-switch d-flex align-self-center"
              onColor="#34c38f"
              offColor="#bfc8e2"
              onHandleColor="#222736"
              offHandleColor="#32394E"
              handleDiameter={10}
              width={28}
              height={16}
              checkedIcon={false}
              uncheckedIcon={false}
              checked={balanceValues?.balancer || false}
              disabled
              onChange={() => {}}
            />
          </div>
        </div>
        <UncontrolledTooltip placement="bottom" target={`balancer`}>
          {t(
            "Distribute chat volumes among agent groups that are sharing the same skill."
          )}
        </UncontrolledTooltip>
      </div>
    );
  };

  const balancerTypeRadio = () => (
    <div className="d-flex justify-content-between w-100">
      <FormGroup>
        <Label id="skill-inactive-time">{t("Balancing type") + " *"}</Label>
        <i
          className="fas fa-info-circle px-2 pointer"
          id={`eventInfoType-${props?.id}`}
        ></i>

        <div>
          <input
            type="radio"
            name="sequential"
            value={"sequential"}
            checked={balanceValues.balancer_type === "sequential"}
            onChange={handleRadioChange}
          />
          {" " + t("sequential") + " "}
        </div>
        <div>
          <input
            type="radio"
            name="proportional"
            value={"proportional"}
            checked={balanceValues.balancer_type === "proportional"}
            onChange={handleRadioChange}
          />
          {" " + t("proportional") + " "}
        </div>
      </FormGroup>
      {tooltipsTypeBalancing()}
    </div>
  );

  const totalPercentage = () => <div>{`Total: ${totalpercent} %`}</div>;

  const balancerTimeoutInput = () => {
    if (balanceValues.balancer_type === "proportional") {
      return (
        <div>
          <FormGroup>
            <Label id="skill-inactive-time">{t("Max time") + " *"}</Label>
            <input
              type="number"
              name="skillinactivitytime"
              className="form-control md-2"
              placeholder={t("Time in minutes")}
              onChange={(e) => {
                setBalanceValues({
                  ...balanceValues,
                  balancer_timeout: e.target.value,
                });
              }}
              defaultValue={
                balanceValues?.balancer_timeout
                  ? balanceValues.balancer_timeout
                  : 0
              }
            />
          </FormGroup>
        </div>
      );
    }
  };

  const balancerConfigGroupsProportional = useCallback(() => (
    <div className="w-100">
      <FormGroup>
        <CustomFormRepeater
          inputRowProps={{ className: "d-flex" }}
          outputRowProps={{ className: "d-flex" }}
          buttonColProps={{
            className: "mb-3 mt-auto",
            sm: 3,
          }}
          errorText={t("Fill all fields")}
          addButtonText={t("Add")}
          addButtonProps={{
            type: "button",
            color: "success",
            className: "waves-effect waves-light w-100 mr-2",
          }}
          deleteButtonText={t("Delete")}
          deleteButtonProps={{
            type: "button",
            color: "danger",
            className: "waves-effect waves-light w-100 mr-2",
          }}
          outputProps={{
            className: "form-control",
            type: "text",
          }}
          fields={proportionalFields}
          value={balanceValues?.balancer_config ?? []}
          onChange={(e) => {
            handleAddGroups(e);
          }}
        />
        <div className="invalid-feedback d-block">
          {t(errors.groupCarga?.message)}
        </div>
      </FormGroup>
    </div>
  ), [balanceValues, proportionalFields, errors.groupCarga?.message]);

  const balancerConfigGroupsSequential = useCallback(() => (
    <div className="w-100">
    <FormGroup>
      <CustomFormRepeater
        inputRowProps={{ className: "d-flex" }}
        outputRowProps={{ className: "d-flex" }}
        buttonColProps={{
          className: "mb-3 mt-auto",
          sm: 3,
        }}
        errorText={t("Fill all fields")}
        addButtonText={t("Add")}
        addButtonProps={{
          type: "button",
          color: "success",
          className: "waves-effect waves-light w-100 mr-2",
        }}
        deleteButtonText={t("Delete")}
        deleteButtonProps={{
          type: "button",
          color: "danger",
          className: "waves-effect waves-light w-100 mr-2",
        }}
        outputProps={{
          className: "form-control",
          type: "text",
        }}
        fields={sequentialFields}
        value={balanceValues?.balancer_config ?? []}
        onChange={(e) => {
          handleAddGroups(e);
        }}
      />
      <div className="invalid-feedback d-block">
        {t(errors.groupCarga?.message)}
      </div>
    </FormGroup>
  </div>
), [balanceValues, sequentialFields, errors.groupCarga?.message]);

  return (
    <>
      <div className="chatEvent d-flex flex-column rounded p-3" style={style}>
        <div className="d-flex align-items-center mb-2">{balancerSwitch()}</div>
        {balanceValues?.balancer && (
          <div>
            <div className="d-flex align-items-center mb-2">
              {balancerTypeRadio()}
            </div>
            <div className="d-flex align-items-center mb-2">
              {balancerTimeoutInput()}
            </div>
            {balanceValues.balancer_type === "proportional" ? (
              <>
                <div className="d-flex align-items-center mb-2">
                  {balancerConfigGroupsProportional()}
                </div>
                <div className="d-flex align-items-right mb-2">
                  {totalPercentage()}
                </div>
              </>
            ) : (
              <div className="d-flex align-items-center mb-2">
                {balancerConfigGroupsSequential()}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default withTranslation()(React.memo(BalancingComponent));
